import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import CustomCursor from "../components/CustomCursor";
import Resume from "./Resume.pdf"; // Ensure this path is correct

const ResumePage = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = Resume;
    link.download = 'Qadeer_Ahmad_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-[#121212] text-white font-sans flex flex-col items-center justify-center relative p-4">
      <CustomCursor />
      <Link to="/" className="absolute top-4 left-4">
        <Button
          variant="outline"
          className="flex items-center gap-2 text-white border-white hover:text-yellow-300 hover:border-yellow-300"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Main Page
        </Button>
      </Link>
      <div className="max-w-4xl w-full bg-gray-800 rounded-lg shadow-lg p-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-yellow-300 flex items-center gap-2">
            <FileText className="h-8 w-8" />
            My Resume
          </h1>
          <Button
            onClick={handleDownload}
            className="flex items-center gap-2 bg-yellow-300 text-black hover:bg-yellow-400"
          >
            <Download className="h-4 w-4" />
            Download Resume
          </Button>
        </div>
        <div className="aspect-[8.5/11] w-full bg-white rounded-lg overflow-hidden">
          <iframe
            src={Resume}
            className="w-full h-full"
            title="Resume"
          />
        </div>
      </div>
    </div>
  );
};

export default ResumePage;
